import { z } from 'zod'

/** Slug sent in `filter[tags_in]` to match companies with no Company tags. */
export const NO_COMPANY_TAGS = '__none__'

/** System Company tags. VIP and Blacklisted share an exclusive group, so a company has one at most. */
export const COMPANY_VIP_TAG_SLUG = 'vip'
export const COMPANY_BLACKLISTED_TAG_SLUG = 'blacklisted'

export const GetCompanyTagTypeSchema = z.object({
  id: z.number(),
  // A system type, such as VIP or Blacklisted, cannot be archived.
  is_system: z.boolean(),
  name: z.string(),
  order: z.number().nullish(),
  slug: z.string(),
})

/** A Company tag named by its type. */
export const GetCompanyTagSchema = z.object({
  id: z.number(),
  tag_type: GetCompanyTagTypeSchema,
})

/**
 * A company's tags as the API sends them. It sends a tag's type only when its relation is loaded,
 * so a tag without one, which could not be named, is dropped.
 */
export const GetCompanyTagsSchema = GetCompanyTagSchema.extend({
  tag_type: GetCompanyTagTypeSchema.nullish(),
})
  .array()
  .transform(tags =>
    tags.flatMap(({ tag_type, ...tag }) => (tag_type ? [{ ...tag, tag_type }] : [])),
  )

export type GetCompanyTag = z.infer<typeof GetCompanyTagSchema>
export type GetCompanyTagType = z.infer<typeof GetCompanyTagTypeSchema>
